import { createSvgComponent } from "../../icon/createSvgComponent";
import MagnifyingGlass from "@core/__generated__/icon/figma/magnifying-glass.svg";
export default createSvgComponent(MagnifyingGlass);